import block from './block/store';
import custom from './custom/store';
import instance from './instance/store';
import prop from './prop/store';
import sectionBar from './section-bar/store';
import texture from './texture/store';
import ueitem from './ueitem/store';

export default {
  namespaced: true,
  modules: {
    block,
    custom,
    instance,
    prop,
    sectionBar,
    texture,
    ueitem,
  },
};
